var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content animate-panel", attrs: { id: "page-warehouses" } },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "box-overview" }, [
        _vm._m(1),
        _vm._v(" "),
        _vm.usingLogiSettings.length
          ? _c(
              "div",
              { staticClass: "box-warehouse-using" },
              [
                _c("div", { staticClass: "warehouse-using-title" }, [
                  _vm._v("利用中の倉庫")
                ]),
                _vm._v(" "),
                _vm._l(_vm.usingLogiSettings, function(usingLogiSetting) {
                  return _c(
                    "div",
                    {
                      key: "usingLogiSetting-" + usingLogiSetting.seq,
                      staticClass: "warehouse-using-item"
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-8 left-item" }, [
                          _c("div", { staticClass: "warehouse-item-header" }, [
                            _c("div", { staticClass: "left-item-header-one" }, [
                              _c("img", {
                                staticClass: "img-responive logi-icon",
                                attrs: {
                                  src: usingLogiSetting.iconUrl,
                                  alt: ""
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "left-item-header-two" }, [
                              _c(
                                "p",
                                {
                                  class:
                                    "logi-kbn m-b-none " +
                                    usingLogiSetting.logiKbnItem.class
                                },
                                [
                                  _vm._v(
                                    _vm._s(usingLogiSetting.logiKbnItem.name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "span",
                                    { staticClass: "logi-name m-b-none" },
                                    [_vm._v(_vm._s(usingLogiSetting.logiName))]
                                  ),
                                  _vm._v(" "),
                                  usingLogiSetting.systemName === "Amazon"
                                    ? [
                                        parseInt(usingLogiSetting.requiredFlg)
                                          ? _c(
                                              "span",
                                              { staticClass: "required-flg" },
                                              [_vm._v("必須")]
                                            )
                                          : _vm._e()
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  usingLogiSetting.systemName === "salmonYamato"
                                    ? [
                                        _c(
                                          "span",
                                          {
                                            class:
                                              "usage-status " +
                                              usingLogiSetting.usageStatusItem
                                                .class
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                usingLogiSetting.usageStatusItem
                                                  .status
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "warehouse-item-content" }, [
                            _c(
                              "div",
                              { staticClass: "left-item-content" },
                              [
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-warning w-150 button-to-warehouse-link mr-b-10",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          _vm.openWarehouseManagement(
                                            usingLogiSetting
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("倉庫管理を開く")]
                                  )
                                ]
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "right-item-content" }, [
                              _c("div", {
                                staticClass: "logi-sumary",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.replaceHTMLSellerInfo(
                                      usingLogiSetting.summary
                                    )
                                  )
                                }
                              })
                            ])
                          ])
                        ])
                      ])
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.initial
          ? _c(
              "div",
              { staticClass: "box-additional-warehouse" },
              [
                _vm._m(2),
                _vm._v(" "),
                _vm.additionalLogiSettings.length
                  ? _vm._l(_vm.additionalLogiSettings, function(
                      additionalLogiSetting
                    ) {
                      return _c(
                        "div",
                        {
                          key:
                            "additionalLogiSetting-" +
                            additionalLogiSetting.seq,
                          staticClass: "warehouse-additional-item"
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-9 left-item" }, [
                              _c(
                                "div",
                                { staticClass: "warehouse-item-header" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "left-item-header-one" },
                                    [
                                      _c("img", {
                                        staticClass: "logi-icon img-responsive",
                                        attrs: {
                                          src: additionalLogiSetting.iconUrl,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "left-item-header-two" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          class:
                                            "logi-kbn m-b-none " +
                                            additionalLogiSetting.logiKbnItem
                                              .class
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              additionalLogiSetting.logiKbnItem
                                                .name
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "span",
                                          { staticClass: "logi-name" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                additionalLogiSetting.logiName
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        !additionalLogiSetting.usageStatusItem
                                          .status &&
                                        parseInt(
                                          additionalLogiSetting.recommendFlg
                                        ) &&
                                        additionalLogiSetting.systemName !==
                                          "salmonYamato"
                                          ? _c(
                                              "span",
                                              { staticClass: "recommend-flg" },
                                              [_vm._v("おすすめ")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        additionalLogiSetting.usageStatusItem
                                          .status
                                          ? _c(
                                              "span",
                                              {
                                                class:
                                                  "usage-status " +
                                                  additionalLogiSetting
                                                    .usageStatusItem.class
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    additionalLogiSetting
                                                      .usageStatusItem.status
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              additionalLogiSetting.systemName ===
                              "salmonYamato"
                                ? _c(
                                    "div",
                                    { staticClass: "warehouse-item-content" },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-size-20 font-bold text-danger"
                                        },
                                        [
                                          _vm._v(
                                            "本サービスは、2025年1月31日をもってサービスを終了しました。"
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "warehouse-item-content" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "left-item-content" },
                                        [
                                          _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn w-150 button-additional-warehouse mr-b-10 btn-info",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    _vm.openAdditionalWarehouseModal(
                                                      additionalLogiSetting
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("追加する")]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "right-item-content" },
                                        [
                                          _c("div", {
                                            staticClass: "logi-sumary",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.replaceHTMLSellerInfo(
                                                  additionalLogiSetting.summary
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                            ]),
                            _vm._v(" "),
                            additionalLogiSetting.systemName ===
                              "salmonYamato" ||
                            (additionalLogiSetting.systemName === "salmonSc" &&
                              _vm.userInfo.scWarehouseUse === "9")
                              ? _c(
                                  "div",
                                  { staticClass: "col-md-3 right-item" },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "link-manage-plan",
                                        attrs: { href: "javascript:void(0)" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            _vm.openUsagePlanManagement(
                                              additionalLogiSetting.systemName
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("費用明細")]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ]
                      )
                    })
                  : [
                      !_vm.initial && !_vm.additionalLogiSettings.length
                        ? _c("div", { staticClass: "pd-t-10 pd-l-45" }, [
                            _vm._v(
                              "\n          追加可能な倉庫はありません\n        "
                            )
                          ])
                        : _vm._e()
                    ]
              ],
              2
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.isShowAdditionalWarehouseModal
        ? _c("additional-warehouse-modal", {
            attrs: { logiSetting: _vm.selectedAdditionalLogiSetting },
            on: { close: _vm.closeAdditionalWarehouseModal }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", { staticClass: "m-n box-warehouse-title" }, [
      _c("div", { staticClass: "warehouse-image" }, [
        _c("img", {
          staticClass: "img-responsive",
          attrs: { src: "/static/dists/img/warehouse.png", alt: "" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "warehouse-title" }, [_vm._v("倉庫管理")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-warehouse-sale" }, [
      _c("div", { staticClass: "warehouse-sale-title" }, [
        _vm._v("倉庫を活用して物販を効率化")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "warehouse-sale-content" }, [
        _vm._v(
          "\n        セールモンスターではセラー様が管理する倉庫、セールモンスターが管理する倉庫を利用することができます。"
        ),
        _c("br"),
        _vm._v(
          "\n        倉庫を活用して出荷作業を効率化することができます。\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warehouse-using-title" }, [
      _c("img", {
        staticClass: "img-reponsive additional-circle",
        attrs: { src: "/static/dists/img/additional_circle.svg", alt: "" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "warehouse-using-title-text" }, [
        _vm._v("追加可能な倉庫")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6817b7be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6817b7be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouses/Warehouses.vue
// module id = null
// module chunks = 